/**
 * Checks if the file object has an empty type and attempts to determine it from the extension.
 * Returns a new File object with the corrected type if necessary, or the original file.
 * @param {File} file - The file object to check.
 * @return {File} - The file object with type ensured.
 */
export const ensureFileType = (file) => {
    if (file.type && file.type !== "") {
        return file;
    }

    const name = file.name;
    const extension = name.split('.').pop().toLowerCase();
    let newType = "";

    switch (extension) {
        case 'idoc':
            newType = 'application/idoc';
            break;
        case 'isheet':
            newType = 'application/isheet';
            break;
        case 'yos':
            newType = 'application/yos'; // Assuming this is another custom type
            break;
        default:
            // leave as is or set to generic binary?
            // If we strictly follow the requirement "if file_type is empty also check for extentions"
            // we only act on known extensions.
            return file;
    }

    if (newType) {
        // Create a new File object with the specific type
        // Note: we use file.slice() to get the blob content efficiently
        const newFile = new File([file], file.name, { type: newType, lastModified: file.lastModified });
        // Preserve webkitRelativePath which is lost when creating a new File object
        if (file.webkitRelativePath) {
            Object.defineProperty(newFile, 'webkitRelativePath', {
                value: file.webkitRelativePath,
                writable: false,
            });
        }
        return newFile;
    }
    
    return file;
};
